import 'ui-core/components/figure-viewer/js/figure-viewer-script';

(function () {
    let figureViewer = UX.figureViewer;

    figureViewer.init = function () {
        figureViewer.expand();
        figureViewer.control();
        figureViewer.doubleTap();
        $('body').nodoubletapzoom();
        $('.figure__highResImgReplacer').length && figureViewer.onHighRes();

        if (!$('.figure-viewer__ctrl__caption').hasClass('js-open')) {
            $('.figure-viewer__ctrl__caption').click();
        }
    };
})();
